<template>
  <div>
    <v-container class="pa-0">
      <div
        v-if="sessionLink.loading"
        class="py-10 px-5 d-flex align-center justify-center h-100"
      >
        <Loading class="pt-5 my-5" />
      </div>
      <div
        v-else-if="inMaintenance"
        class="py-10 px-5 d-flex align-center justify-center h-100"
      >
        <Maintenance />
      </div>
      <div
        v-else-if="sessionLink.data && sessionLink.data.sessionLinkTypeId === 1"
        class="py-5"
      >
        <Detail
          :sessionLink="sessionLink.data"
          @verifyLink="verifyLink"
        />
      </div>
      <div v-else-if="sessionLink.data && sessionLink.data.sessionLinkTypeId === 2">
        <Go
          v-if="['active'].includes(status)"
          :sessionLink="sessionLink.data"
        />
        <div v-else-if="['used', 'progress'].includes(status)" class="d-flex align-center justify-center h-100 pa-5">
          <UsedLink :content="sessionLink.data" />
        </div>
        <div v-else-if="status === 'expired'" class="d-flex align-center justify-center h-100 pa-5">
          <ExpiredLink :content="sessionLink.data" />
        </div>
      </div>
      <div v-else class="d-flex align-center justify-center h-100 pa-5">
        <EmptyLink />
      </div>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

require('@/sockets/socket')
require('@/services/SessionLink')

@Component({
  components: {
    Loading: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Loading.vue'),
    Maintenance: () => import(/* webpackPrefetch: true */ '@/components/Maintenance.vue'),
    EmptyLink: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/EmptyLink.vue'),
    UsedLink: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/UsedLink.vue'),
    ExpiredLink: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/ExpiredLink.vue'),
    Detail: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Detail.vue'),
    Go: () => import(/* webpackPrefetch: true */ '@/views/session-link/resources/Go.vue')
  }
})
export default class Index extends Vue {
  data () {
    return {
      sessionLink: {
        loading: true,
        verifying: false,
        data: null
      },
      inMaintenance: false,
      status: null,
    }
  }

  async mounted () {
    this.token = this.$route.params.token
    this.organizationName = this.$route.params.organizationName

    this.verifyLink()
  }

  async verifyLink () {
    if (this.sessionLink.verifying) {
      return false
    }

    this.sessionLink.verifying = true

    this.$sessionLink
      .getSessionLink(this.token, this.organizationName)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.sessionLink.data = res.data
          const organization = this.sessionLink.data.organization
          this.setDefaultConfig(organization.primaryColor, organization.locale)

          this.status = this.sessionLink.data.status
        } else if (res.statusCode === 11) {
          this.inMaintenance = true;
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .then(() => {
        this.sessionLink.verifying = false
        this.sessionLink.loading = false
      })
  }

  setDefaultConfig (primaryColor, locale) {
    this.$vuetify.theme.themes.light.primary = primaryColor
    this.$vuetify.theme.themes.dark.primary = primaryColor
    this.$i18n.locale = locale
  }
}
</script>
